import { Link } from '@amzn/awsui-components-react';
import { BaseNavigationDetail } from '@amzn/awsui-components-react/polaris/internal/events';
import { useContext } from 'react';

import { HelpPanelTopicOptions } from '../../common/Constants';
import { HelpPanelContext } from '../../contexts/HelpPanelContext';

export const InfoLink = ( props: {topic: HelpPanelTopicOptions, className?: string} ) => {
    const helpPanelContext = useContext(HelpPanelContext);
    const onFollowHandler = (event: CustomEvent<BaseNavigationDetail>) => {
        event.preventDefault();
        helpPanelContext.panelHandler(props.topic);
        if (helpPanelContext.isPanelOpen) {
            helpPanelContext.panelClose();
        } else {
            helpPanelContext.panelOpen();
        }
    };
    return (
        <Link
            variant='info'
            onFollow={onFollowHandler}
            className={props.className}
        >
            Info
        </Link>
    );
};
